var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgc yangben"},[_c('div',{staticClass:"yangben_title title"},[_vm._v("样本数")]),_c('div',{staticClass:"yangben_text"},[_vm._v(" 县："+_vm._s(_vm.yangBenShuData.aData)+" 个                      乡/镇/社区："+_vm._s(_vm.yangBenShuData.bData)+"个                      村："+_vm._s(_vm.yangBenShuData.cData)+"个")])])
}
var staticRenderFns = []

export { render, staticRenderFns }